module.exports = octokitDebug;

function octokitDebug(octokit) {
  octokit.hook.wrap('request', function (request, options) {
    octokit.log.debug("request", options);
    var start = Date.now();
    var requestOptions = octokit.request.endpoint.parse(options);
    var path = requestOptions.url.replace(options.baseUrl, '');
    return request(options).then(function (response) {
      octokit.log.info("".concat(requestOptions.method, " ").concat(path, " - ").concat(response.status, " in ").concat(Date.now() - start, "ms"));
      return response;
    }).catch(function (error) {
      octokit.log.info("".concat(requestOptions.method, " ").concat(path, " - ").concat(error.status, " in ").concat(Date.now() - start, "ms"));
      throw error;
    });
  });
}